import { render, staticRenderFns } from "./OrganizationContactSelector.vue?vue&type=template&id=ab3a2218&scoped=true"
import script from "./OrganizationContactSelector.vue?vue&type=script&lang=js"
export * from "./OrganizationContactSelector.vue?vue&type=script&lang=js"
import style0 from "./OrganizationContactSelector.vue?vue&type=style&index=0&id=ab3a2218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3a2218",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAutocomplete,VChip,VIcon})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
